import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-2 mb-10 md:mb-14">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Shop by <br className="hidden md:block" />Category
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-md leading-relaxed mt-2 lg:mt-1">
            Browse our complete collection of fashion categories. Each category links directly to the oopbuy spreadsheet product catalog for seamless shopping.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.slug}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-100 rounded-lg overflow-hidden hover:ring-2 hover:ring-primary-300/50 transition-all duration-200 cursor-pointer"
            >
              {/* Image */}
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={`${cat.name} - oopbuy spreadsheet category`}
                  title={`${cat.name} products on OOPBuy Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
              </div>
              {/* Label */}
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-400 mt-0.5 whitespace-nowrap">
                  {cat.description}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}